//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import accordion from '~/mixins/accordion'

export default {
  mixins: [accordion],
  props: {
    targetedPackage: Object,
    packageId: String
  }
}

